import { createContext, useCallback, useContext, useState } from "react";
import { WaitlistDialog } from "@/components/site/WaitlistDialog";
import { pauseScroll } from "@/lib/scroll";

const WaitlistContext = createContext({ openWaitlist: () => {} });

export const WaitlistProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, plan: null, source: null });

  const openWaitlist = useCallback((opts = {}) => {
    pauseScroll(true);
    setState({ open: true, plan: opts.plan || null, source: opts.source || null });
  }, []);

  const onOpenChange = (open) => {
    pauseScroll(open);
    setState((s) => ({ ...s, open }));
  };

  return (
    <WaitlistContext.Provider value={{ openWaitlist }}>
      {children}
      <WaitlistDialog {...state} onOpenChange={onOpenChange} />
    </WaitlistContext.Provider>
  );
};

export const useWaitlist = () => useContext(WaitlistContext);
